// extracted by mini-css-extract-plugin
export default {"container":"SampleCartModal_container__IrKua","cartItems":"SampleCartModal_cartItems__ZwNsf","imgDiv":"SampleCartModal_imgDiv__eG2LL"};